/**
 * TrustpilotStrip Component
 * Trustpilot rating banner
 */
const assetsUrl = `${window.template_root}/src/public/`;

export function TrustpilotStrip() {
  return (
    <a
      href="https://www.trustpilot.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="block bg-trustpilot py-6 transition-all hover:bg-[#13201a]
                 max-md:py-5 max-md:px-2"
      aria-label="View Trustpilot reviews"
    >
      <div
        className="max-w-[1200px] mx-auto flex gap-6 items-center justify-center
                      text-white text-base leading-tight
                      max-md:gap-2 max-md:text-center max-md:text-[0.95rem]"
      >
        <p className="m-0 font-medium">
          Check out our <strong>28,435 reviews</strong>
        </p>
        {/* Trustpilot Stars */}
        <img
          src={`${assetsUrl}img/tp-stars.svg`}
          alt="Trustpilot 4.5 star rating"
          className="h-[25px] w-auto max-md:h-[15px]"
        />
        {/* Trustpilot Logo */}
        <img
          src={`${assetsUrl}img/tp-logo.svg`}
          alt="Trustpilot"
          className="h-5 w-auto max-md:hidden"
        />
      </div>
    </a>
  );
}

export default TrustpilotStrip;
